import { Routes } from '@angular/router';

export const OPS_MANAGEMENT_ROUTES: Routes = [
  {
    path: 'training-planning',
    loadComponent: () =>
      import('./components/training-planning/training-planning.component').then((m) => m.TrainingPlanningComponent),
  },
  {
    path: 'cohort-delay',
    loadComponent: () =>
      import('./components/cohort-delay/cohort-delay.component').then((m) => m.CohortDelayComponent),
  },
  {
    path: 'difficulty-review',
    loadComponent: () =>
      import('./components/difficulty-review/difficulty-review.component').then((m) => m.DifficultyReviewComponent),
  },
  {
    path: 'training-priority',
    loadComponent: () =>
      import('./components/training-priority/training-priority.component').then(
        (m) => m.TrainingPriorityComponent
      ),
  },
  { path: '', redirectTo: 'training-priority', pathMatch: 'full' },
];
